// src/utils/translations/ResetPasswordFormTranslations.js
const translations = {
  fr: {
    newPasswordPlaceholder: "Nouveau mot de passe",
    showPasswordAria: "Afficher le mot de passe",
    hidePasswordAria: "Masquer le mot de passe",
    confirmPasswordPlaceholder: "Confirmer le mot de passe",
    passwordsDontMatch: "Les mots de passe ne correspondent pas.",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères.",
    submit: "Réinitialiser"
  },
  en: {
    newPasswordPlaceholder: "New password",
    showPasswordAria: "Show password",
    hidePasswordAria: "Hide password",
    confirmPasswordPlaceholder: "Confirm password",
    passwordsDontMatch: "Passwords do not match.",
    passwordMinLength: "Password must be at least 8 characters long.",
    submit: "Reset"
  },
  de: {
    newPasswordPlaceholder: "Neues Passwort",
    showPasswordAria: "Passwort anzeigen",
    hidePasswordAria: "Passwort ausblenden",
    confirmPasswordPlaceholder: "Passwort bestätigen",
    passwordsDontMatch: "Passwörter stimmen nicht überein.",
    passwordMinLength: "Das Passwort muss mindestens 8 Zeichen enthalten.",
    submit: "Zurücksetzen"
  },
  es: {
    newPasswordPlaceholder: "Nueva contraseña",
    showPasswordAria: "Mostrar contraseña",
    hidePasswordAria: "Ocultar contraseña",
    confirmPasswordPlaceholder: "Confirmar contraseña",
    passwordsDontMatch: "Las contraseñas no coinciden.",
    passwordMinLength: "La contraseña debe tener al menos 8 caracteres.",
    submit: "Restablecer"
  },
  it: {
    newPasswordPlaceholder: "Nuova password",
    showPasswordAria: "Mostra password",
    hidePasswordAria: "Nascondi password",
    confirmPasswordPlaceholder: "Conferma password",
    passwordsDontMatch: "Le password non coincidono.",
    passwordMinLength: "La password deve contenere almeno 8 caratteri.",
    submit: "Reimposta"
  }
};

export default translations;
